export var atLeastOneValueTruthy = function atLeastOneValueTruthy(obj) {
  return Object.values(obj).some(function (val) {
    return val;
  });
};